<app-header></app-header>

<div class="container-fluid" style="width: 80%;">
  <div class="row mt-4 mb-4">
    <div class="col">
      <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
        <ol class="breadcrumb mb-0 p-0">
          <li class="breadcrumb-item"><a routerLink="/home">Home</a><span class="separator">/</span></li>
          <li class="breadcrumb-item active" aria-current="page">Il mio profilo</li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="row mt-4 mb-4">
    <div class="col">
      <h4>Il mio profilo</h4>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <mat-card appearance="outlined">
        <mat-card-header>
          <mat-card-title><b>Utente</b></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p class="mb-0"><strong>Username:</strong> {{ username }}</p>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div class="row mt-4 g-3">
    <div class="col-12 col-md-6">
      <mat-card appearance="outlined" class="h-100">
        <mat-card-header>
          <mat-card-title><b>COT abilitate</b></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          @if (loading) {
            <div class="d-flex align-items-center gap-2">
              <mat-spinner diameter="24"></mat-spinner>
              <span>Caricamento...</span>
            </div>
          } @else if (cotAbilitate.length === 0) {
            <p class="text-muted mb-0">Nessuna COT abilitata per il tuo utente.</p>
          } @else {
            <ul class="mb-0 list-unstyled">
              @for (cot of cotAbilitate; track cot.id) {
                <li>{{ cot.codice }} – {{ cot.descrizione ?? '—' }}</li>
              }
            </ul>
          }
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-12 col-md-6">
      <mat-card appearance="outlined" class="h-100">
        <mat-card-header>
          <mat-card-title><b>Tipi segnalazione</b></mat-card-title>
          <mat-card-subtitle>Usati per il precaricamento del filtro nel cruscotto richieste</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          @if (loadingTipi) {
            <div class="d-flex align-items-center gap-2">
              <mat-spinner diameter="24"></mat-spinner>
              <span>Caricamento...</span>
            </div>
          } @else if (tipiSegnalazione.length === 0) {
            <p class="text-muted mb-2">Nessun tipo segnalazione associato. Puoi gestirli per pre-filtrare le richieste nel cruscotto.</p>
          } @else {
            <ul class="mb-2 list-unstyled">
              @for (t of tipiSegnalazione; track t.id) {
                <li>{{ t.codice ?? '—' }} – {{ t.descrizione ?? '—' }}</li>
              }
            </ul>
          }
          <button mat-raised-button color="primary" (click)="gestisciTipiSegnalazione()">
            Gestisci tipi segnalazione
          </button>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>

<app-footer></app-footer>
